import { render, staticRenderFns } from "./TeledeclarationCancelDialog.vue?vue&type=template&id=146e304d&"
import script from "./TeledeclarationCancelDialog.vue?vue&type=script&lang=js&"
export * from "./TeledeclarationCancelDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports